__turbopack_context__.v({
  "avatarShell": "TripCuratorsSection-module__Alaf1W__avatarShell",
  "body": "TripCuratorsSection-module__Alaf1W__body",
  "content": "TripCuratorsSection-module__Alaf1W__content",
  "heading": "TripCuratorsSection-module__Alaf1W__heading",
  "section": "TripCuratorsSection-module__Alaf1W__section",
});
